import { render, staticRenderFns } from "./Moq.vue?vue&type=template&id=40775e51"
import script from "./Moq.vue?vue&type=script&lang=js"
export * from "./Moq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports